"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.XPTransactionHistoryItemTypeEnum = exports.XPTransactionHistoryItemToJSON = exports.XPTransactionHistoryItemFromJSONTyped = exports.XPTransactionHistoryItemFromJSON = void 0;
var runtime_1 = require("../runtime");
function XPTransactionHistoryItemFromJSON(json) {
    return XPTransactionHistoryItemFromJSONTyped(json, false);
}
exports.XPTransactionHistoryItemFromJSON = XPTransactionHistoryItemFromJSON;
function XPTransactionHistoryItemFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !(0, runtime_1.exists)(json, 'id') ? undefined : json['id'],
        'amount': !(0, runtime_1.exists)(json, 'amount') ? undefined : json['amount'],
        'type': !(0, runtime_1.exists)(json, 'type') ? undefined : json['type'],
        'subject': !(0, runtime_1.exists)(json, 'subject') ? undefined : json['subject'],
        'description': !(0, runtime_1.exists)(json, 'description') ? undefined : json['description'],
        'createdAt': !(0, runtime_1.exists)(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
    };
}
exports.XPTransactionHistoryItemFromJSONTyped = XPTransactionHistoryItemFromJSONTyped;
function XPTransactionHistoryItemToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'amount': value.amount,
        'type': value.type,
        'subject': value.subject,
        'description': value.description,
        'createdAt': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
    };
}
exports.XPTransactionHistoryItemToJSON = XPTransactionHistoryItemToJSON;
/**
* @export
* @enum {string}
*/
var XPTransactionHistoryItemTypeEnum;
(function (XPTransactionHistoryItemTypeEnum) {
    XPTransactionHistoryItemTypeEnum["DEBIT"] = "DEBIT";
    XPTransactionHistoryItemTypeEnum["CREDIT"] = "CREDIT";
})(XPTransactionHistoryItemTypeEnum = exports.XPTransactionHistoryItemTypeEnum || (exports.XPTransactionHistoryItemTypeEnum = {}));
